import type { IConsentGroup } from '../types/IConsentConfig';
import { Tracker, TrackerFactory } from '../types/Tracker';
import { trackCurrentPage } from '../zoho-webassistant';

export const trackingConsentGroup: IConsentGroup = {
  key: 'tracking',
  title: 'Website-Statistiken',
  items: [
    {
      title: 'Matomo Analytics',
      description: 'Analyse von Seitenbesuchen',
      key: 'allowMatomoTracking',
      action(isActive, event) {
        handleActionForTracker({
          isActive,
          tracker: TrackerFactory.getMatomoTracker(),
          handleEvent: () => {
            console.log('Track Matomo Page');
            // @ts-expect-error _paq is defined by matomo
            _paq.push(['setCustomUrl', document.location.href]);
            // @ts-expect-error same error
            _paq.push(['trackPageView']);
          },
        });
      },
    },
    {
      title: 'Zoho Webassistent',
      description: 'Analyse von Seitenbesuchen',
      key: 'allowZohoTracking',
      action(isActive, event) {
        handleActionForTracker({
          isActive,
          tracker: TrackerFactory.getZohoTracker(),
          handleEvent: async () => {
            console.log('Track Zoho Page');
            trackCurrentPage();
          },
        });
      },
    },
  ],
};

async function handleActionForTracker({
  isActive,
  tracker,
  handleEvent,
}: {
  isActive: boolean;
  tracker?: Tracker;
  handleEvent?: () => void;
}) {
  if (!tracker) return;

  // 1. ensure to deactivate and return
  if (!isActive) return tracker.removeTrackingScripts();

  // 2. attach tracking script
  await tracker.attachTrackingScripts();

  // 3. handle events
  if (!handleEvent) return;

  handleEvent();
}
